module.exports = __webpack_public_path__ + "static/media/Bitmap.241f30c4.png";